import { ReactNode } from "react";
import { cn } from "@utils/utils";
import styles from "./UsedCarSeoShared.module.scss";

interface UsedCarSeoSectionProps {
  children: ReactNode;
  tone?: "default" | "dark" | "grey" | "white";
  deferred?: boolean;
  className?: string;
  innerClassName?: string;
}

export default function UsedCarSeoSection({
  children,
  tone = "default",
  deferred = false,
  className,
  innerClassName,
}: UsedCarSeoSectionProps) {
  return (
    <section
      className={cn(
        styles.section,
        tone === "dark" && styles.darkSection,
        tone === "grey" && styles.greySection,
        tone === "white" && styles.whiteSection,
        deferred && styles.deferredSection,
        className
      )}
    >
      <div className={cn(styles.sectionInner, innerClassName)}>{children}</div>
    </section>
  );
}
